import { Route, UrlMatchResult, UrlSegment } from '@angular/router';

/**
 * Matchea /vacantes/categoria/:slug/pais/:slug/ciudad/:slug en cualquier
 * subconjunto de esos 3 pares (categoria, pais, ciudad), siempre como pares
 * prefijo+valor — así nunca choca con /vacantes/:slug (detalle de una
 * vacante, que es siempre un único segmento).
 */
const PREFIJOS: Record<string, string> = {
  categoria: 'categoriaSlug',
  pais: 'paisSlug',
  ciudad: 'ciudadSlug',
};

export function vacantesFiltradasMatcher(segments: UrlSegment[]): UrlMatchResult | null {
  if (segments.length === 0 || segments.length % 2 !== 0) return null;

  const posParams: Record<string, UrlSegment> = {};
  for (let i = 0; i < segments.length; i += 2) {
    const prefijo = segments[i].path;
    const paramName = PREFIJOS[prefijo];
    if (!paramName) return null;
    posParams[paramName] = segments[i + 1];
  }

  return { consumed: segments, posParams };
}

export const vacantesFiltradasRoute: Route = {
  matcher: vacantesFiltradasMatcher,
  loadComponent: () =>
    import('../../features/vacantes/vacantes.component').then((m) => m.VacantesComponent),
};
